<template>
  <div>
    <div class="container">
      <div class="row no-margin">
        <h5 class="overview-h5">{{ $t('add_new_call') }}</h5>
      </div>
      <div>
        <div>
          <ValidationObserver v-slot="{ handleSubmit }">
            <b-form
              @submit.prevent="handleSubmit(saveServiceCall)"
              @reset="reset"
              v-if="show"
              enctype="multipart/form-data"
            >
              <b-form-group
                id="subject-group"
                label-cols="3"
                :label="$t('subject')"
                label-for="call-subject"
              >
                <ValidationProvider
                  name="call-subject"
                  rules="required"
                  v-slot="{ classes, errors }"
                >
                  <b-form-input
                    id="call-subject"
                    type="text"
                    v-model="serviceCall.subject"
                    :class="classes"
                  ></b-form-input>
                  <span class="validation-error">{{ $t(errors[0]) }}</span>
                </ValidationProvider>
              </b-form-group>

              <b-form-group
                id="message-group"
                label-cols="3"
                :label="$t('message')"
                label-for="message"
              >
                <ValidationProvider name="message" rules="required" v-slot="{ classes, errors }">
                  <b-form-textarea
                    id="message"
                    v-model="serviceCall.message"
                    type="text"
                    :rows="3"
                    :max-rows="6"
                    :class="classes"
                  ></b-form-textarea>
                  <span class="validation-error">{{ $t(errors[0]) }}</span>
                </ValidationProvider>
              </b-form-group>

              <b-form-group
                id="order-reference-group"
                label-cols="3"
                :label="$t('order_reference')"
                label-for="order-reference"
              >
                <ValidationProvider
                  name="order-reference"
                  rules="required"
                  v-slot="{ classes, errors }"
                >
                  <b-form-input
                    id="order-reference"
                    type="text"
                    v-model="serviceCall.orderReference"
                    :class="classes"
                  ></b-form-input>
                  <span class="validation-error">{{ $t(errors[0]) }}</span>
                </ValidationProvider>
              </b-form-group>

              <b-form-group
                id="contact-person-group"
                label-cols="3"
                :label="$t('contact_person')"
                label-for="contact-person"
              >
                <ValidationProvider
                  name="contact-person"
                  rules="required"
                  v-slot="{ classes, errors }"
                >
                  <b-form-input
                    id="contact-person"
                    type="text"
                    v-model="serviceCall.contactPerson"
                    :class="classes"
                  ></b-form-input>
                  <span class="validation-error">{{ $t(errors[0]) }}</span>
                </ValidationProvider>
              </b-form-group>

              <b-form-group
                id="phone-number-group"
                label-cols="3"
                :label="$t('phone_number')"
                label-for="phone-number"
              >
                <b-form-input
                  id="phone-number"
                  type="text"
                  v-model="serviceCall.phoneNumber"
                  placeholder
                ></b-form-input>
              </b-form-group>

              <b-form-group
                id="email-contact-person-group"
                label-cols="3"
                :label="$t('email_contact_person')"
                label-for="email-contact-person"
              >
                <ValidationProvider
                  name="contact-person"
                  rules="muliptle-email"
                  v-slot="{ classes, errors }"
                >
                <b-form-input
                  id="email-contact-person"
                  type="text"
                  v-model="serviceCall.emailContactPerson"
                   :class="classes"
                ></b-form-input>
                  <span class="validation-error">{{ $t(errors[0]) }}</span>
                </ValidationProvider>
              </b-form-group>

              <b-form-group
                id="retrieve-device-group"
                label-cols="3"
                :label="$t('retrieve_device')"
                label-for="retrieve-device"
              >
                <b-form-checkbox class="add-call-checkbox" v-model="serviceCall.retrieveDevice" />
              </b-form-group>

              <div v-show="serviceCall.retrieveDevice">
                <b-form-group
                  id="device-clean-dirt-group"
                  label-cols="3"
                  :label="$t('device_clean_dirt')"
                  label-for="device-clean-dirt"
                  v-show="showCleanDirtOption()"
                >
                  <b-form-row>
                    <b-col cols="3">
                      <multiselect
                        class="call-add-multiselect"
                        v-model="serviceCall.deviceOption"
                        :options="deviceOptions"
                        :showLabels="false"
                        label="name"
                        track-by="name"
                        placeholder
                      >
                        <template slot="singleLabel" slot-scope="props">
                          <span class="option__desc">
                            <span class="option__title">{{ props.option.name }}</span>
                          </span>
                        </template>
                        <template slot="option" slot-scope="props">
                          <div
                            class="option__desc template-device-option"
                          >
                            <span class="option__title">{{ props.option.name }}</span>
                          </div>
                        </template>
                      </multiselect>
                    </b-col>
                    <b-col
                      cols="9"
                      style="text-align: right;"
                      v-show="serviceCall.deviceOption.value == 'dirty'"
                    >
                      <b-button
                        style="font-size: 12px; padding: 9px 12px;"
                        v-on:click="downloadPackagingInstructionsDocument()"
                      >{{$t('download_packaging_instructions')}}</b-button>
                    </b-col>
                  </b-form-row>
                  <b-form-row>
                    <span
                      style="padding-left: 5px; color: green;"
                      v-show="serviceCall.deviceOption.value == 'clean'"
                    >{{$t('machine_cleaned_successfully')}}</span>
                    <span v-html="$t('not_machine_cleaned')"
                      style="padding-left: 5px; color: firebrick;"
                      v-show="serviceCall.deviceOption.value == 'dirty'"
                    >
                    </span>
                  </b-form-row>
                </b-form-group>

                <b-form-group
                  id="retrieve-date-group"
                  label-cols="3"
                  :label="$t('retrieve_date')"
                  label-for="retrieve-date"
                >
                  <b-form-row>
                    <b-col cols="4">
                      <ValidationProvider
                        name="email-contact-person"
                        :rules="`${serviceCall.retrieveDevice ? 'required' : ''}`"
                        v-slot="{ classes, errors }"
                      >
                        <vc-date-picker
                          locale="nl-NL"
                          mode="single"
                          v-model="serviceCall.retrieveDate"
                          id="email-contact-person"
                          type="text"
                          class="add-call-date-picker"
                          :class="classes"
                        />
                        <span class="validation-error">{{ $t(errors[0]) }}</span>
                      </ValidationProvider>
                    </b-col>
                  </b-form-row>
                </b-form-group>

                <b-form-group
                  id="pick-up-address-group"
                  label-cols="3"
                  :label="$t('pick_up_address')"
                  label-for="pick-up-address"
                >
                  <ValidationProvider
                    name="pick-up-address"
                    :rules="`${serviceCall.retrieveDevice ? 'required' : ''}`"
                    v-slot="{ classes, errors }"
                  >
                    <b-form-textarea
                      id="pick-up-address"
                      v-model="serviceCall.pickUpAddress"
                      type="text"
                      :rows="3"
                      :max-rows="6"
                      :class="classes"
                    ></b-form-textarea>
                    <span class="validation-error">{{ $t(errors[0]) }}</span>
                  </ValidationProvider>
                </b-form-group>
              </div>

              <b-form-group
                id="download-buttons"
                label-cols="3"
                v-show="showDownloadButtons()"
                label="Documenten"
              >
                <b-button v-on:click="downloadRepairRequestForm()">{{$t('repair_request_form')}}</b-button>
                <b-button
                  v-on:click="downloadDecontaminationDeclarationDocument()"
                >{{$t('decontamination_declaration')}}</b-button>
              </b-form-group>

              <b-form-row>
                <b-col cols="3">{{$t('attachments')}}</b-col>
                <b-col cols="9">
                  <file-upload
                    class="btn btn-primary"
                    extensions="jpg,jpeg,bmp,tiff,png,mov,pdf,txt,log,msg,doc,docx,tif,raw,dcm,avi,mp4,mpg,mpeg,3gp,dat,xls,xlsx"
                    accept="image/png, image/jpeg, image/bmp, image/tiff, application/pdf, text/plain, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, video/x-msvideo, video/3gpp, audio/3gpp, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    :multiple="true"
                    :size="1024 * 1024 * 5"
                    v-model="files"
                    :uploadAuto="true"
                    :maximum="10"
                    @input-filter="inputFilter"
                    @input-file="inputFile"
                    ref="upload"
                  >
                    <i class="fa fa-plus"></i>
                    {{ $t('select_files') }}
                  </file-upload>
                </b-col>
                <b-col cols="3"></b-col>
                <b-col cols="9">
                  <div
                    class="upload"
                    style="border: 1px solid #ced4da; border-radius: 0.25rem; margin-top: 8px;"
                    v-show="files.length"
                  >
                    <ul
                      style="list-style-type:none; padding-left: 12px; padding-top: 8px; margin-bottom: 8px;"
                    >
                      <li v-for="file in files" :key="file.id">
                        <span @click.prevent="$refs.upload.remove(file)">
                          <font-awesome-icon
                            :icon="['fas', 'times']"
                            style="color: #dc3545; cursor: pointer; margin-right: 8px; text-decoration: none;"
                          />
                        </span>
                        <span>{{file.name}}</span>
                        <span v-if="file.error" style="color: red;">{{$t(file.error)}}</span>
                        <span v-else></span>
                      </li>
                    </ul>
                  </div>
                </b-col>
              </b-form-row>

              <b-form-row v-show="files.length">
                <b-col cols="3"></b-col>
                <b-col cols="9">
                  <label
                    style="padding-top: 8px; font-weight: 700;"
                  >{{ $t('please_anonymize_the_uploaded_documents')}}</label>
                </b-col>
              </b-form-row>

              <b-form-row style="margin-top: 8px;">
                <b-button type="submit" :disabled="isSaving">{{ $t('send') }}</b-button>
                <b-button
                  type="reset"
                  :disabled="isDisabled()"
                  style="margin-left: 16px;"
                >{{ $t('reset') }}</b-button>
              </b-form-row>

              <b-form-checkbox class="send-copy" v-model="sendCopy">
                <b>{{ $t('send_copy_to', { email: name }) }}</b>
              </b-form-checkbox>

              <b-alert v-if="errorMessage" show variant="danger">{{errorMessage}}</b-alert>
            </b-form>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { user } from './../../user.js';

export default {
  name: 'ServiceCallAdd',
  props: ['serviceObject'],
  data: function() {
    return {
      serviceCall: {
        subject: '',
        message: '',
        objectId: '',
        orderReference: '',
        userEmailAddress: '',
        contactPerson: '',
        phoneNumber: '',
        retrieveDevice: false,
        deviceOption: { name: this.$t('clean'), value: 'clean' },
        deviceCleanDirt: '',
        retrieveDate: null,
        pickUpAddress: this.$t('collection_will_take_place_at_goods_receipt')
      },
      errorMessage: null,
      isSaving: false,
      name: user.userName,
      sendCopy: false,
      show: true,
      deviceOptions: [
        { name: this.$t('clean'), value: 'clean' },
        { name: this.$t('dirt'), value: 'dirty' }
      ],
      files: []
    };
  },
  beforeMount() {},
  mounted() {},
  methods: {
    isDisabled() {
      return false;
    },
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Before adding a file
        // Filter system files or hide files
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent();
        }
        // Filter php html js file
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent();
        }
      }
    },
    inputFile(newFile, oldFile) {
      if (
        Boolean(newFile) !== Boolean(oldFile) ||
        oldFile.error !== newFile.error
      ) {
        if (!this.$refs.upload.active) {
          this.$refs.upload.active = true;
        }
      }
    },
    reset: function(e) {
      e.preventDefault();

      this.serviceCall = {};
      this.serviceCall.pickUpAddress = this.$t(
        'collection_will_take_place_at_goods_receipt'
      );
      this.serviceCall.deviceOption = {
        name: this.$t('clean'),
        value: 'clean'
      };

      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
    showCleanDirtOption: function() {
      if (this.serviceObject.objectType != null) {
        return this.serviceObject.department === 'EN';
      }

      return false;
    },
    showDownloadButtons: function() {
      if (this.serviceObject.objectType != null) {
        return this.serviceObject.department === 'EN';
      }

      return false;
    },
    saveServiceCall: function(e) {
      this.isSaving = true;
      this.errorMessage = '';

      var items = [];
      var fileNames = [];

      this.files.forEach(item => {
        if (item.error === 'No action configured') {
          items.push(item.file);
          fileNames.push(item.file.name);
        }
      });

      this.serviceCall.serviceObjectId = this.$route.params.id;
      this.serviceCall.deviceCleanDirt = this.serviceCall.deviceOption.value;
      this.serviceCall.sendAttachmentsSeparately = items.length > 0;

      this.serviceCall.attachments = fileNames;

      this.serviceCall.retrieveDate = this.$moment(
        this.serviceCall.retrieveDate
      ).add(12, 'hours');

      if (this.sendCopy) {
        this.serviceCall.userEmailAddress = user.displayName;
      }

      let promise = this.$axios.post('servicecalls', this.serviceCall, {
        headers: {
          'Content-Type': 'application/json'
        }
      });

      return promise
        .then(response => {
          var createdServiceCall = response.data;

          if (items.length > 0) {
            uploadServiceCall(createdServiceCall, items, this);
          }

          this.isSaving = false;

          this.$emit('servicecall-created', createdServiceCall);

          // Clear form upon success
          this.serviceCall = {};
          this.files = [];
          this.serviceCall.pickUpAddress = this.$t(
            'collection_will_take_place_at_goods_receipt'
          );
          this.serviceCall.deviceOption = {
            name: this.$t('clean'),
            value: 'clean'
          };

          this.show = false;
          this.$nextTick(() => {
            this.show = true;
          });
        })
        .catch(error => {
          console.log(error);

          this.isSaving = false;

          if (error.response.status === 404) {
            // Service object not found
            this.errorMessage = this.$t('service_object_not_found');
          } else {
            this.errorMessage = error;
          }
        });
    },
    downloadPackagingInstructionsDocument: function() {
      var url =
        'servicecalls/getnewservicecalldocument?documentType=PackagingInstructions';
      var fileName = 'packaging-instructions.pdf';

      downloadDocument(this, url, fileName);
    },
    downloadRepairRequestForm: function() {
      var url =
        'servicecalls/getnewservicecalldocument?documentType=RepairRequestForm';
      var fileName = 'repair-request-form.pdf';

      downloadDocument(this, url, fileName);
    },
    downloadDecontaminationDeclarationDocument: function() {
      var url =
        'servicecalls/getnewservicecalldocument?documentType=DecontaminationDeclaration';
      var fileName = 'decontamination-declaration-fhm-medical-v1.1.pdf';

      downloadDocument(this, url, fileName);
    }
  }
};

function downloadDocument(context, url, fileName) {
  context.$axios({
    url: url,
    method: 'GET',
    responseType: 'blob'
  })
    .then(response => {
      if (navigator.msSaveBlob) {
        return navigator.msSaveBlob(new Blob([response.data]), fileName);
      } else {
        const url = window.URL.createObjectURL(new Blob([response.data]));

        const link = window.document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        window.document.body.appendChild(link);
        link.click();
      }
    })
    .catch(error => {
      console.log(error);
    });
}

function uploadServiceCall(serviceCallId, items, context) {
  var bodyFormData = new FormData();
  items.forEach(item => {
    bodyFormData.append('file', item, item.name);
  });

  context
    .$axios({
      method: 'post',
      url: 'upload?serviceCallId=' + serviceCallId,
      data: bodyFormData,
      headers: { 'Content-Type': 'multipart/form-data' },
      transformRequest: (data, request) => {
        // This is all that matters
        return data;
      }
    })
    .then(function(response) {
      // handle success
    })
    .catch(function(response) {
      // handle error
      console.log(response);
    });
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  background-color: white;
  text-align: left;
}

b-alert {
  margin-top: 15px;
}

.send-copy {
  margin-top: 16px;
}

.btn-secondary {
  background-color: #6c757d;
}

.add-call-checkbox {
  padding-top: 6px;
}

.validation-error {
  color: #dc3545;
}
</style>

<style>
.add-call-date-picker .vc-text-base {
  padding: 8px 12px;
  height: 38px;
  font-size: 16px !important;
}

#device-clean-dirt-group {
  margin-bottom: 0.5rem;
}

.call-add-multiselect .multiselect__option {
  background-color: white !important;
  padding: 0;
}

.template-device-option {
  padding: 12px;
}

.call-add-multiselect .multiselect__option--selected {
  font-weight: normal;
}

.call-add-multiselect .multiselect__option--highlight {
  background-color: #f3f3f3 !important;
  color: #35495e !important;
  font-weight: 700 !important;
}
</style>
